import React from "react"
import { createRoot } from "react-dom/client"
import App from "./Components/App"
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

const container = document.getElementById("root")
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container)

  root.render(
    <React.StrictMode>
      <App publicClientApp={msalInstance} />
    </React.StrictMode>
  );

